import React from 'react'
import classNames from 'classnames'
import Avatar from 'design-system/avatar'
import { AvatarSizes } from 'design-system/avatar/src/resources/Avatar.enum'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserTie } from '@fortawesome/pro-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import avatarDefault from 'assets/avatar-loading-xxl.svg'
import CommonToolTip from '../tooltip/commonToolTip'
import styles from './SupervisorAvatar.module.scss'

interface IAvatarUserProps {
  user: any
  className?: string
  showSupervisor?: boolean
  showPosition?: boolean
  classes?: { userName?: string }
  supervisors?: any
}

const SupervisorAvatar: React.FC<IAvatarUserProps> = ({
  user,
  className,
  children,
  showSupervisor = false,
  showPosition = true,
  classes,
}) => {
  const fullName = user.fullName
    ? user.fullName
    : `${user.name} ${user.lastname}`
  const avatar = user.avatar ? user.avatar : avatarDefault

  const { t } = useTranslation()
  const { userName } = { ...classes }
  return (
    <div
      className={`d-flex align-items-center ${styles.container} ${
        className || ''
      }`}
    >
      <Avatar
        src={avatar}
        sizes={AvatarSizes.Medium}
        className={`${styles.img} mr-2 avatarImg`}
      />
      <div className="d-inline-block w-100">
        <p
          className={classNames(
            `m-0 pt-2 basic-title ${styles.userName}`,
            userName
          )}
        >
          {fullName}
          {showSupervisor && user.roleId && (
            <CommonToolTip
              text={t(`configuration.user.isSupervisor`)}
              position="right"
              className={styles.tabsTooltip}
            >
              <FontAwesomeIcon
                icon={faUserTie}
                className={`ml-1 ${styles.adminIcon}`}
              />
            </CommonToolTip>
          )}
        </p>
        {showPosition && (
          <small
            className={`grey-darken basic-position ${styles.userPosition}`}
          >
            {user.position}
          </small>
        )}
        {children}
      </div>
    </div>
  )
}

export default SupervisorAvatar
